<template>
  <el-dialog
    :visible.sync="dialogVisible"
    width="380px"
    :before-close="handleClose"
    :close-on-click-modal="canClose"
  >
    <div class="bind-box">
      <template v-if="!isSupplyAccount">
        <div class="bind-title">绑定原登录账号</div>
      </template>
      <template v-if="avatar">
        <img :src="avatar" class="bind-avatar" />
      </template>
      <template v-else>
        <img src="~@/images/user_avatar.png" class="bind-avatar" />
      </template>
      <div class="bind-phone">{{ phone | hidePhone }}</div>

      <template v-if="!showFillBox">
        <template v-if="login_todo === 'bind_exist'">
          <!-- 绑定已有账号 -->
          <div class="bind-btn_wrap">
            <div class="bind-confirm" @click="clickBindBtn('bind-login')">
              直接绑定并登录
            </div>
            <div class="bind-other" @click="clickBindBtn('bind-other')">
              绑定其他原登录账户
            </div>
          </div>
          <!-- <div class="bind-tip">
            检测到{{ platform_name }}有{{ phone | hidePhone }}，是否绑定到{{
              phone | hidePhone
            }}？
          </div> -->
          <div class="bind-tip">检测到您已有和当前登录账户相同手机号的账户</div>
        </template>
        <template v-if="isSupplyAccount">
          <!-- 没有找到绑定，进行补充信息 -->
          <div class="bind-btn_wrap" v-if="platform !== 'ild'">
            <div class="bind-confirm" @click="clickBindBtn('supply-info')">
              补充信息
            </div>
            <div class="bind-other" @click="clickBindBtn('bind-other')">
              绑定其他原登录账户
            </div>
          </div>
          <div class="bind-btn_wrap" v-if="platform === 'ild'">
            <div class="bind-confirm" @click="clickBindBtn('supply-info')">
              补充信息
            </div>
            
          </div>
          <!-- <div class="bind-tip">
            没有检测到{{ platform_name }}有{{ phone | hidePhone }}，是否绑定到{{
              phone | hidePhone
            }}？
          </div> -->
          <div class="bind-tip">请补全该系统需要的个人信息字段</div>
        </template>
      </template>
      <template v-if="showFillBox">
        <div class="bind-fill_box">
          <template v-if="showPhoneFill">
            <div class="fill-line">
              <div class="fill-label">手机号：</div>
              <div class="fill-cont">
                <el-input
                  v-model="bindOtherPhone"
                  style="width: 210px"
                  placeholder="请输入手机号"
                ></el-input>
              </div>
            </div>
            <div class="fill-line">
              <div class="fill-label">验证码：</div>
              <div class="fill-cont">
                <el-input
                  v-model="bindCode"
                  style="width: 120px"
                  placeholder="请输入验证码"
                ></el-input>
                <span class="get-code" @click="clickCodeBtn">{{
                  isCounting ? timeCount + "s" : "获取验证码"
                }}</span>
              </div>
            </div>
          </template>

          <template v-if="platform === 'hxylt'">
            <div class="fill-line">
              <div class="fill-label">姓名：</div>
              <div class="fill-cont">
                <el-input v-model="bindName" clearable></el-input>
              </div>
            </div>
          </template>
          <template v-else-if="platform === 'pccm'">
            <template v-if="!isBindExistAccount && !isbindOtherAccount">
              <template v-if="role === 'hospital'">
                <PccmUserFill ref="pccmUserRef"></PccmUserFill>
              </template>
              <template v-if="role === 'specialist'">
                <IldSpecialFill ref="pccmSpecialRef"></IldSpecialFill>
              </template>
            </template>
          </template>
          <template v-else-if="platform === 'ild'">
            <template v-if="!isBindExistAccount && !isbindOtherAccount">
              <template v-if="role === 'hospital'">
                <IldUserFill ref="ildUserRef"></IldUserFill>
              </template>
              <template v-if="role === 'specialist'">
                <PccmSpecialFill ref="ildSpecialRef"></PccmSpecialFill>
              </template>
            </template>
          </template>
        </div>
        <div class="bind-no-need" v-if="!needSupply">无需补充信息</div>
        <div class="bind-submit" @click="clickSubmit" v-if="platform !== 'ild'">
          {{ needSupply ? "提交" : "提交并自动登录" }}
        </div>
        <div class="bind-submit" @click="clickIldSubmit" v-else>
          {{ needSupply ? "提交" : "提交并自动登录" }}
        </div>
      </template>
    </div>
  </el-dialog>
</template>
<script>
import { mapState } from "vuex";
import { PLATFORMS } from "@/utils/enum";
import { fetchUserBind, fetchSendSms, fetchUserInfo } from "@/api/user";
import codeMixin from "@/mixins/codeMixin";
import todoMixin from "@/mixins/todoMixin";
import PccmUserFill from "../components/pccmUserFill";
import PccmSpecialFill from "../components/pccmSpecialFill";
import IldUserFill from "../components/ildUserFill";
import IldSpecialFill from "../components/ildSpecialFill";
export default {
  name: "WorkbenchBind",
  mixins: [codeMixin, todoMixin],
  components: {
    PccmUserFill,
    PccmSpecialFill,
    IldUserFill,
    IldSpecialFill
  },
  computed: {
    ...mapState("user", [
      "phone",
      "avatar",
      "name",
      "login_todo",
      "platform",
      "redirect",
      "role",
      "common_token",
    ]),
    canClose() {
      return false;
    },
    platform_name() {
      const { platform } = this;

      let platform_name = "";
      const platform_data = PLATFORMS[platform];
      if (platform_data) {
        platform_name = platform_data.name;
      }
      return platform_name;
    },
    // 是否补充账户信息
    isSupplyAccount() {
      return (
        this.login_todo === "bind_none" || this.login_todo === "bind_supply"
      );
    },
    // 是否绑定存在的账户
    isBindExistAccount() {
      return this.login_todo === "bind_exist";
    },
    // 是否需要补充信息
    needSupply() {
      const { platform, role, clickBtnType } = this;

      if (
        clickBtnType == "supply-info" &&
        platform === "zxdx" &&
        (role == "hospital" || role == "student" || role == "specialist")
      ) {
        return false;
      } else if (
        clickBtnType == "supply-info" &&
        platform === "hospital" &&
        role == "doctor"
      ) {
        return false;
      } else {
        return true;
      }
    },
  },
  data() {
    return {
      dialogVisible: true,
      //绑定姓名
      bindName: "",
      bindOtherPhone: "",
      bindCode: "",
      showFillBox: false,
      showPhoneFill: false,
      isbindOtherAccount: false,
      clickBtnType: "",
    };
  },
  mounted() {
    const { login_todo } = this;
    if (login_todo === "bind_supply") {
      this.showFillBox = true;
    }
  },
  methods: {
    checkSms() {
      const { bindOtherPhone } = this;
      if (!bindOtherPhone) {
        this.$message({
          message: "请输入手机号",
          type: "error",
        });
        return false;
      }
      return true;
    },
    fetchSmsApi() {
      const { bindOtherPhone } = this;
      fetchSendSms({
        phone: bindOtherPhone,
      });
    },
    // 获取补充信息的姓名
    getFillName() {
      const { platform, role, common_token } = this;
      fetchUserInfo({
        platform,
        role,
        common_token,
      }).then((res) => {
        console.log(res);
        const { code, data } = res;
        if (code === 0 && data) {
          const { name } = data;
          this.bindName = name;
        }
      });
    },
    //点击绑定按钮
    clickBindBtn(type) {
      this.showFillBox = true;
      this.isbindOtherAccount = false;
      this.clickBtnType = type;

      console.log(type, "type");
      if (type === "bind-login") {
        //绑定登录
        this.getFillName();
      } else if (type === "bind-other") {
        //绑定其他
        this.showPhoneFill = true;
        this.isbindOtherAccount = true;
      } else if (type === "supply-info") {
        //补充信息
        this.getFillName();
      }
    },
    handleClose() {
      setTimeout(() => {
        this.$router.replace({
          name: "WorkbenchHome",
        });
      }, 200);
    },
    clickSubmit() {
      const {
        showPhoneFill,
        bindOtherPhone,
        phone,
        platform,
        role,
        bindCode,
        bindName,
        redirect,
        common_token,
        isBindExistAccount,
        isbindOtherAccount,
      } = this;

      let submits = {
        platform,
        role,
        redirect,
        common_token,
        is_bind: 1,
      };

      if (showPhoneFill) {
        if (!bindOtherPhone) {
          this.$message({
            message: "请输入手机号",
            type: "error",
          });
          return;
        }
        if (!bindCode) {
          this.$message({
            message: "请输入验证码",
            type: "error",
          });
          return;
        }
        submits.phone = bindOtherPhone;
        submits.code = bindCode;
        // 绑定其他
        submits.is_bind = 0;
      } else {
        submits.phone = phone;
      }

      if (platform === "hxylt") {
        if (!bindName) {
          this.$message({
            message: "请选择输入姓名",
            type: "error",
          });
          return;
        }
        submits = Object.assign(submits, {
          name: bindName,
        });
      } else if (platform === "pccm") {
        // 该账号已绑定角色 或者 该角色绑定其他账号 则不验证
        if (!isBindExistAccount && !isbindOtherAccount) {
          if (role === "hospital") {
            const pccmSubmit = this.$refs["pccmUserRef"].check();
            if (!pccmSubmit) {
              return;
            }
            submits = Object.assign(submits, pccmSubmit);
          } else if (role === "specialist") {
            const pccmSubmit = this.$refs["pccmSpecialRef"].check();
            if (!pccmSubmit) {
              return;
            }
            submits = Object.assign(submits, pccmSubmit);
          }
        }
      }
      console.log(submits,'submits');
      // return
      this.$confirm("确认提交吗？")
        .then(() => {
          fetchUserBind(submits).then((res) => {
            const { code, data } = res;
            if (code === 0) {
              const { do: todo } = data;
              this.handleTodo(todo);
            }
          });
        })
        .catch(() => {});
    },
    clickIldSubmit() {
      const {
        showPhoneFill,
        bindOtherPhone,
        phone,
        platform,
        role,
        bindCode,
        bindName,
        redirect,
        common_token,
        isBindExistAccount,
        isbindOtherAccount,
      } = this;

      let submits = {
        platform,
        role,
        redirect,
        common_token,
        is_bind: 1,
      };

      if (showPhoneFill) {
        if (!bindOtherPhone) {
          this.$message({
            message: "请输入手机号",
            type: "error",
          });
          return;
        }
        if (!bindCode) {
          this.$message({
            message: "请输入验证码",
            type: "error",
          });
          return;
        }
        submits.phone = bindOtherPhone;
        submits.code = bindCode;
        // 绑定其他
        submits.is_bind = 0;
      } else {
        submits.phone = phone;
      }

       if (platform === "ild") {
        // 该账号已绑定角色 或者 该角色绑定其他账号 则不验证
        if (!isBindExistAccount && !isbindOtherAccount) {
          if (role === "hospital") {
            const pccmSubmit = this.$refs["ildUserRef"].check();
            if (!pccmSubmit) {
              return;
            }
            submits = Object.assign(submits, pccmSubmit);
          } else if (role === "specialist") {
            const pccmSubmit = this.$refs["ildSpecialRef"].check();
            if (!pccmSubmit) {
              return;
            }
            submits = Object.assign(submits, pccmSubmit);
          }
        }
      }
      console.log(submits)
      // return
      this.$confirm("确认提交吗？")
        .then(() => {
          fetchUserBind(submits).then((res) => {
            const { code, data } = res;
            if (code === 0) {
              const { do: todo } = data;
              this.handleTodo(todo);
            }
          });
        })
        .catch(() => {});
    },
  },
};
</script>
<style lang="scss" scoped>
@import "./index.scss";
</style>
